import React, { FC } from 'react';
import { SingleOption } from 'app/pages/Survey/Subject/elements';
import { NestChildProps } from '../types';
import { createNest } from '../createNest';
import { useNestAnswer } from '../hooks';
import { useStyles } from './styles';

const NestMobileChild: FC<NestChildProps> = ({ options }) => {
  const { id, text, valueFromAnswer, onChange } = useNestAnswer();
  const styles = useStyles();

  return (
    <div className={styles.rowContainer} data-subject-id={id}>
      <p className={styles.categoryText}>{text}</p>
      {options.map(({ Id, label, value }) => {
        const checked = valueFromAnswer === value;

        return (
          <SingleOption
            key={value}
            Id={Id}
            value={value}
            className={styles.radioClassNameMobile}
            textClassName={styles.textClassName}
            inverse
            size="small"
            label={label}
            checked={checked}
            onChange={onChange}
          />
        );
      })}
    </div>
  );
};

export default createNest(NestMobileChild);
